import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { Bullet } from './styled/Bullet';
import PropTypes from 'prop-types';

const CustomOption = (props) => {
	const { color, label, remark, belowLine } = props;

	const remarks = Array.isArray(remark) ? remark : [remark];

	return (
		<Box sx={{ opacity: belowLine ? 0.6 : 1 }}>
			<Box>
				{color && <Bullet color={color} />}
				{label}
			</Box>
			{remark && remarks.length > 0 && (
				<Box>
					{remarks.map((r, i) => {
						return typeof r !== 'string' ? (
							r
						) : (
							<Typography key={i} variant="subtitle2" color="secondary">
								{r}
							</Typography>
						);
					})}
				</Box>
			)}
		</Box>
	);
};

CustomOption.propTypes = {
	label: PropTypes.string,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	color: PropTypes.string, // hex - '#f1f1f1'
	belowLine: PropTypes.bool,
	remark: PropTypes.oneOfType([
		PropTypes.node,
		PropTypes.arrayOf(PropTypes.node),
	]),
};

export default CustomOption;
